var Target = /** @class */ (function () {
    function Target() {
        this.targets = [];
    }
    Target.create = function () {
        return new Target();
    };
    Target.byFilter = function (filters, name, isOlap) {
        return new Target().add(filters, name, isOlap);
    };
    Target.prototype.add = function (filters, name, isOlap) {
        this.targets.push({
            filters: filters,
            name: name,
            isOlap: isOlap
        });
        return this;
    };
    Target.prototype.toGlobalEmbedTarget = function () {
        return this.targets.map(function (x) {
            return {
                name: x.name,
                filters: x.filters.toGlobalEmbedFilters(),
                olap: x.isOlap
            };
        });
    };
    return Target;
}());
export { Target };
